<template>
    <section class="FAQ">
       <Nav title="常见问题" />
       <van-tabs v-model="active">
           <van-tab title="开户认证">
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="怎么注册(开户)？" name="1">
			           <p>因为目前没有开放注册，所以开户需要联系客服/商务操作。添加客服微信，把公司名称、主账号操作人姓名、手机号发过去开户。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="只有公司才可以开户？个人可以开吗？" name="2">
			           <p>个人也可以开，但是需要有公司信息，你自己的公司或者你上班的公司都可以。或者个体户也可以。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="这个平台是什么模式？" name="3">
			           <p>是推单模式，就是你添加推广计划，计划里设置好你的筛选条件，申请过来的客户符合你的条件就自动给你推送，不符合就不推。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="APP/网站具体怎么使用？" name="4">
			           <p>具体使用流程：开户，认证（微信公众号上提交“账户认证”和“机构认证”），订阅软件（选择版本），充值，添加推广计划（设置推送条件和资质条件），开始推送。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="入门版/专业版/旗舰版三个版本有什么区别？" name="5">
			           <p>1. 团队结构不同：入门版和专业版都是“管理员”--“业务员”两层结构，旗舰版是“管理员”--“团队”--“业务员”三层结构️；</p>
			           <p>2. 业务员账号（子账号）数量不同：入门版默认2个，且不能付费增加，专业版默认10个，可以付费增加至30个，旗舰版默认50个，付费增加无上限；</p>
			           <p>3. 获客范围不同：入门版只能本省获客，专业版和旗舰版均可全国获客；</p>
					   <p>4. 同时投放的计划数量：入门版3个，专业版10个，旗舰版100个。但是累计投放的计划数均没有限制；</p>
					   <p>5. 管理员分配订单方式：入门版只能自动分配订单给业务员（自动分配逻辑为：轮流平均），专业版和旗舰版除了自动分配方式外，还有手动分配方式。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="我该选择哪个版本订阅？" name="6">
			           <p>选择版本最重要的因素是你一起使用这个系统的团队大小，如果就是一个人用，或者3个人以下，就选入门版。如果使用团队在3-20人，建议专业版，如果超过20人，建议旗舰版。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="认证审核需要提交什么材料？" name="7">
			           <p>一、机构认证，提供：</p>
			           <p>1. 营业执照照片；<br> 2. 门头（前台）logo照片；<br> 3. 办公环境视频；<br> 4. 相关产品资料（比如和客户的协议、产品介绍、收费截图等等）；<br> 5. 持牌机构合作协议；<br> 6. 其他补充资料。</p>
			           <p>其中1-4是必填，5-6是选填。</p>
			           <p> 二、账户认证，提供： </p>
			           <p>1. 身份证正反面照片；<br> 2. 真人办公照片；<br> 3. 工作证明照片。</p>
			       </van-collapse-item>
			   </van-collapse>
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="认证失败一般有哪些原因？" name="8">
                       <p>1. 输入信息不准确，比如姓名，身份证号输入不对；</p>
                       <p>2. 提供的资料和公司对不上；</p>
                       <p>3. 资料虚假。</p>
                   </van-collapse-item>
               </van-collapse>
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="认证需要多久才能通过？" name="9">
                       <p>1. 工作日提交认证，1个工作日完成审核；</p>
                       <p>2. 非工作日提交认证，1-2个工作日完成审核。</p>
                   </van-collapse-item>
               </van-collapse>
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="认证失败，如何能通过展业牛牛认证？" name="10">
                       <p>审核标准是多维度的，核心是判断业务真实性，请按照微信公众号认证页面提示的失败原因， 再次上传相关证明材料，重新提交认证。</p>
                   </van-collapse-item>
               </van-collapse>

               <van-collapse v-model="activeNames">
                   <van-collapse-item title="认证时，身份证等照片无法上传？" name="11">
                       <p>请保证照片大小不超过10M，视频不超过100M，否则无法上传。</p>
                   </van-collapse-item>
               </van-collapse>
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="换了公司，换了城市怎么更改？" name="12">
                       <p>您好，换公司或换城市需要重新认证，app【我的】-【机构认证】或者【账户认证】页面-点击【重新认证】进行更换资料或公司，或者联系客服处理。</p>
                   </van-collapse-item>
               </van-collapse>
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="认证都通过了,已经正常使用了,为啥突然认证状态变成失败或未认证了？" name="14">
                       <p>这种情况需要联系客服或者商务处理。</p>
                   </van-collapse-item>
               </van-collapse>
           </van-tab>
           <van-tab title="费用相关">
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="都有哪些费用？" name="21">
                       <p>会员费，会员费多少和你选择的软件版本有关，各个版本具体区别，在“开户认证”里查阅具体答案。入门版的会员费用是按季度支付，专业版和旗舰版是按年支付。另外就是推广余额充值，目前是3000起充，后期不排除调整，以充值页面为准。</p>
                   </van-collapse-item>
               </van-collapse>
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="具体单个投放线索的成本是多少？" name="23">
                       <p>具体要看城市和筛选的资质条件，可以在推广计划页面选择条件进行预估，或者咨询客服/商务。</p>
                   </van-collapse-item>
               </van-collapse>
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="量大可以优惠吗？" name="25">
                       <p>可以，如果你每天的投放需求量很大，可以联系客服/商务要一个优惠折扣。</p>
                   </van-collapse-item>
               </van-collapse>
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="如果用了一部分,后面不想用了,充值的余额可以退吗？" name="27">
                       <p>可以，充值的余额可以申请退款，但是首次充值需要消耗50%以后才能申请退款。联系客服给你申请就行。但是软件一旦使用，会员费不退。</p>
                   </van-collapse-item>
               </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="联系不上,不是本人,不需要,资质不符等订单可以退吗？" name="29">
			           <p>因为是委托实时投放，没有退单一说，但是如果有停机、空号的以及上述的情况可以申请补单。</p>
			       </van-collapse-item>
			   </van-collapse>
           </van-tab>
           <van-tab title="业务和使用">
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="咱们是在哪里获客(投放渠道是哪些)？" name="32">
			           <p>百度，微信，以及相关app上投放的页面广告，客户看到广告，填写申请表单进来。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="有固定的话术吗？" name="33">
			           <p>没有固定的话术，主要依据你自己的行业经验。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="客户的申请平台或者产品名称是什么？" name="34">
			           <p>用户申请的平台名称（产品名称）在“订单详情-流转记录”里查看，那里有个“推广名称”，就是用户申请的平台名称或者产品名称。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="创建推广计划有几种方式？" name="35">
			           <p>2种，你可以自己在微信公众号个人中心上“推广”页面点右上角+号进行创建添加，也可以找商务客服在后台为你添加，无论哪种方式添加的推广计划，你在app上都可以看到。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="推广计划可以变更或暂停吗？" name="36">
			           <p>可以，其实，计划达到设置的任何一个条件，当天就会自动暂停，比如设置时间之外，推送量已到设置的日目标量，不是推送设置的天等等。如果还是需要人工临时暂停或者改条件，是需要联系我们给你编辑或者暂停计划，计划推送首日不接受临时人工暂停。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="可以多个计划同时运行吗？" name="37">
			           <p>可以。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="每天可以设置推送的量,推送时间吗？" name="38">
			           <p>可以，在添加推广计划的时候除了可以设置筛选资质条件，还可以设置每天几点到几点推送，每天推送单量，周几推送等相关设置项。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames" v-show="false">
			       <van-collapse-item title="投放结果有质量分级吗？" name="39">
			           <p>目前渠道主要分为3级：A级优质，B级标准，C级特价。所有级别都可以筛选条件，只是就整体的联系率、需求率、资质来说，A级好于B级，B级好于C级。当然成本也是A最最高，C最低。客户量是A最小，C最大。你可以选择一个级别的渠道跑，也可以三个同时跑（同时跑的计划只能我们后台给你建）。</p>
			       </van-collapse-item>
			   </van-collapse>
			   <van-collapse v-model="activeNames">
			       <van-collapse-item title="如果一个计划运行到一半这个计划不想要了,怎么办？" name="40">
			           <p>可以联系商务客服要么变更计划继续运行，或者终止这个计划，首次充值的计划需要消耗50%才能终止。</p>
			       </van-collapse-item>
			   </van-collapse>
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="订单主要分哪几个大类？" name="41">
                       <p>从大的层面上来说订单分两大类：一类是委托平台推广获得的订单，我们称之为“平台订单”，一类是机构自己的订单，通过添加或者导入上平台的订单，我们称之为“私有订单”。就是说本平台既可以管理获得的订单，也可以管理自己的订单</p>
                   </van-collapse-item>
               </van-collapse>
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="订单分配给团队或者业务员有哪几种方式？" name="42">
                       <p>目前订单分配主要有两种类型：“自动分配”和“手动分配”。自动分配是订单进来后自动平均轮流的分配给下面的团队和业务员。手动分配是订单进来后并不分配给下面的团队或者业务员，需要管理员手动分配。系统默认的是自动分配，你可以在设置-分单规则那里更改。</p>
                   </van-collapse-item>
               </van-collapse>
               <van-collapse v-model="activeNames">
                   <van-collapse-item title="某个订单已经分配,我可以重新再分配给别的团队或者业务员吗？" name="44">
                       <p>可以，找你的管理员给你直接重新分配。</p>
                   </van-collapse-item>
               </van-collapse>
           </van-tab>
       </van-tabs>
   </section>
</template>

<script>
import Nav from "components/Nav";

export default {
   name: "question",
   components: {
       Nav,
   },
   data() {
       return {
           active: 0,
           activeNames: ['0'],
       };
   },
   mounted() {
       if(this.$store.state.clientType==2) {
           document.addEventListener('plusready', function() { 
               var webview = plus.webview.currentWebview(); 
               plus.key.addEventListener('backbutton', function() {
                   webview.canBack(function(e) {
                       if(e.canBack) {
                           webview.back()
                       }else {
                           webview.close();
                       }
                   })
               })
           }) 
       }
   },
   created() {
        if(this.$route.params.active) this.active = this.$route.params.active*1;
        if(this.$route.params.activeNames) this.activeNames = [this.$route.params.activeNames];
   },
   methods: {},
};
</script>

<style lang="scss">
.FAQ {
   padding-top: 46px;
   .van-tabs__wrap {
       .van-tab {
           color: #2b2f3a;
       }
       .van-tab__text {
           font-size: 16px;
       }
       .van-tab--active {
           color: #3A5EEC;
       }
   }
   .van-tabs__line {
       width: 26px;
       height: 3px;
       background: #3A5EEC;
       border-radius: 1px;
   }
   .van-cell {
       height: 57px;
       align-items: center;
       padding: 0 16px;
       color: #2B2F3A;
   }
   .van-cell__title {
       font-size: 16px;
   }
   .van-icon__image, .check {
       width: 26px;
       height: 26px;
   }
   .van-cell__right-icon {
       font-size: 18px;
       color: #2B2F3A;
   }
   .van-collapse-item__title--expanded::after,
   .van-cell::after {
       display: none;
   }
   .van-hairline--top-bottom::after,
   .van-hairline-unset--top-bottom::after {
       border: 0;
       border-top: 1px solid #f6f6f6;
   }
   .van-collapse-item__content {
       color: #575e72;
       font-size: 14px;
       p {
           padding-bottom: 8px;
       }
   }
   
}
</style>


// WEBPACK FOOTER //
// src/views/setting/FAQ/FAQ.vue